console.log('QUICK-ADD-RELOCATE: le script démarre');

// Déplace le bouton "quick-add" natif (rendu par défaut À L'INTÉRIEUR de
// .card-gallery, qui a overflow:hidden) pour qu'il devienne un frère de
// .card-gallery — juste après la photo, avant le bloc titre/prix.
//
// Un MutationObserver reprocesse la grille à chaque mise à jour (filtre, tri,
// pagination infinie), car ces actions remplacent le HTML de la section.
(function () {
  function relocate() {
    try {
      document.querySelectorAll('product-card:not([data-quick-add-relocated])').forEach(function (card) {
        var quickAdd = card.querySelector('.quick-add');
        var gallery = card.querySelector('.card-gallery');
        if (quickAdd && gallery) {
          gallery.insertAdjacentElement('afterend', quickAdd);
        }
        card.setAttribute('data-quick-add-relocated', 'true');
      });
    } catch (error) {
      console.error('quick-add-relocate error:', error);
    }
  }

  // type="module" s'exécute après le parsing du DOM (déféré par nature) :
  // pas besoin d'attendre DOMContentLoaded, qui pourrait déjà être passé.
  relocate();
  var observer = new MutationObserver(relocate);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();